<template>
  <div class="page">
    <c-source-form
      :columns="columns"
      :data="data"
      @submit="handleCreate"
    >
      <ProductsPicker
        ref="productsPickerForm"
      />
    </c-source-form>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import createColumns from './columns';
import _ from 'lodash';
import { DEFAULT_ORDER_BY } from '@/constants';
import ProductsPicker from './products-picker';

@Component({
  components: { ProductsPicker }
})
export default class TabmodulesNew extends Vue {

  data = {}

  get columns() {
    return [
      ...createColumns(),
      {
        prop: 'key',
        label: '唯一标识',
        form: {
          component: 'input',
          required: true
        }
      },
      {
        prop: 'default_order_by',
        label: '产品排序方式',
        form: {
          component: 'select',
          props: {
            options: _.map(DEFAULT_ORDER_BY, (label, value) => ({ label, value }))
          }
        }
      },
    ]
  }

  async handleCreate(data) {
    const productsPickerForm = this.$refs.productsPickerForm.submit();
    const res = await this.$autoLoading(
      this.$request.post('/tab_modules', { ...data, ...productsPickerForm })
    );
    this.$router.push({ name: 'tab_modules.show', params: { id: res.id } });
  }
}
</script>
